import { createContext, useContext } from 'react';
import { useBlockHeight } from '../hooks/useBlockHeight';

const BlockHeightContext = createContext(null);

export function BlockHeightProvider({ children }) {
  const value = useBlockHeight();
  return (
    <BlockHeightContext.Provider value={value}>
      {children}
    </BlockHeightContext.Provider>
  );
}

export function useBlockHeightContext() {
  return useContext(BlockHeightContext);
}
